<template>
  <div class="content" v-if="route.name == 'Beranda'">
    <Beranda/>
  </div>
  <div class="content" v-if="route.name == 'DaftarKonten'">
    <DaftarKonten/>
  </div>
  <div class="content" v-if="route.name == 'DaftarBerita'">
    <DaftarBerita/>
  </div>
  <div class="content" v-if="route.name == 'DaftarDokumen'">
    <DaftarDokumen/>
  </div>
  <div class="content" v-if="route.name == 'DaftarGaleri'">
    <DaftarGaleri/>
  </div>
  <div class="content" v-if="route.name == 'GIS'">
    <GIS/>
  </div>
  <div class="content" v-if="route.name == 'InputAduan'">
    <InputAduan/>
  </div>
  <div class="content" v-if="route.name == 'CariAduan'">
    <CariAduan/>
  </div>
  <div class="content" v-if="route.name == 'MonitoringAduan'">
    <MonitoringAduan/>
  </div>
  <div class="content" v-if="route.name == 'DaftarProgramBudgeting'">
    <DaftarProgramBudgeting/>
  </div>
  <div class="content" v-if="route.name == 'DaftarFinance'">
    <DaftarFinance/>
  </div>
  <div class="content" v-if="route.name == 'DaftarGESIAP'">
    <DaftarGESIAP/>
  </div>
  <div class="content" v-if="route.name == 'Dashboard'">
    <Dashboard/>
  </div>
  <div class="content" v-if="route.name == 'InfoBeranda'">
    <InfoBeranda/>
  </div>
  <div class="content" v-if="route.name == 'ProsesInfoBeranda'">
    <ProsesInfoBeranda/>
  </div>
  <div class="content" v-if="route.name == 'Konten'">
    <Konten/>
  </div>
  <div class="content" v-if="route.name == 'ProsesKonten'">
    <ProsesKonten/>
  </div>
  <div class="content" v-if="route.name == 'Berita'">
    <Berita/>
  </div>
  <div class="content" v-if="route.name == 'ProsesBerita'">
    <ProsesBerita/>
  </div>
  <div class="content" v-if="route.name == 'DataDokumen'">
    <DataDokumen/>
  </div>
  <div class="content" v-if="route.name == 'Galeri'">
    <Galeri/>
  </div>
  <div class="content" v-if="route.name == 'ProsesGaleri'">
    <ProsesGaleri/>
  </div>
  <div class="content" v-if="route.name == 'DetailGaleri'">
    <DetailGaleri/>
  </div>
  <div class="content" v-if="route.name == 'LayerPeta'">
    <LayerPeta/>
  </div>
  <div class="content" v-if="route.name == 'User'">
    <User/>
  </div>
  <div class="content" v-if="route.name == 'ProsesUser'">
    <ProsesUser/>
  </div>
  <div class="content" v-if="route.name == 'Monev'">
    <Monev/>
  </div>
  <div class="content" v-if="route.name == 'ProsesMonev'">
    <ProsesMonev/>
  </div>
  <div class="content" v-if="route.name == 'ProsesPDOMonev'">
    <ProsesPDOMonev/>
  </div>
  <div class="content" v-if="route.name == 'AduanMasyarakat'">
    <AduanMasyarakat/>
  </div>
  <div class="content" v-if="route.name == 'ProsesAduanMasyarakat'">
    <ProsesAduanMasyarakat/>
  </div>
  <div class="content" v-if="route.name == 'TindaklanjutAduanMasyarakat'">
    <TindaklanjutAduanMasyarakat/>
  </div>
  <div class="content" v-if="route.name == 'PDOIOS'">
    <PDOIOS/>
  </div>
  <div class="content" v-if="route.name == 'ProsesPDOIOS'">
    <ProsesPDOIOS/>
  </div>
  <div class="content" v-if="route.name == 'Kegiatan'">
    <Kegiatan/>
  </div>
  <div class="content" v-if="route.name == 'ProsesKegiatan'">
    <ProsesKegiatan/>
  </div>
  <div class="content" v-if="route.name == 'Program'">
    <Program/>
  </div>
  <div class="content" v-if="route.name == 'ProsesProgram'">
    <ProsesProgram/>
  </div>
  <div class="content" v-if="route.name == 'Procurement'">
    <Procurement/>
  </div>
  <div class="content" v-if="route.name == 'ProsesProcurement'">
    <ProsesProcurement/>
  </div>
  <div class="content" v-if="route.name == 'Finance'">
    <Finance/>
  </div>
  <div class="content" v-if="route.name == 'ProsesFinance'">
    <ProsesFinance/>
  </div>
  <div class="content" v-if="route.name == 'Social'">
    <Social/>
  </div>
  <div class="content" v-if="route.name == 'ProsesSocial'">
    <ProsesSocial/>
  </div>
  <div class="content" v-if="route.name == 'Environment'">
    <Environment/>
  </div>
  <div class="content" v-if="route.name == 'ProsesEnvironment'">
    <ProsesEnvironment/>
  </div>
  <div class="content" v-if="route.name == 'Gesiap'">
    <Gesiap/>
  </div>
  <div class="content" v-if="route.name == 'ProsesGesiap'">
    <ProsesGesiap/>
  </div>
  <div class="content" v-if="route.name == 'Slider'">
    <Slider/>
  </div>
  <div class="content" v-if="route.name == 'ProsesSlider'">
    <ProsesSlider/>
  </div>
  <div class="content" v-if="route.name == 'SettingMenu'">
    <SettingMenu/>
  </div>
</template>

<script>
import Beranda from './components/views/Publik/Beranda.vue';
import DaftarKonten from './components/views/Publik/DaftarKonten.vue';
import DaftarBerita from './components/views/Publik/DaftarBerita.vue';
import DaftarDokumen from './components/views/Publik/DaftarDokumen.vue';
import DaftarGaleri from './components/views/Publik/DaftarGaleri.vue';
import GIS from './components/views/Publik/GIS.vue';
import InputAduan from './components/views/Publik/InputAduan.vue';
import CariAduan from './components/views/Publik/CariAduan.vue';
import MonitoringAduan from './components/views/Publik/MonitoringAduan.vue';
import DaftarProgramBudgeting from './components/views/Publik/DaftarProgramBudgeting.vue';
import DaftarFinance from './components/views/Publik/DaftarFinance.vue';
import DaftarGESIAP from './components/views/Publik/DaftarGESIAP.vue';
import Dashboard from './components/views/Dashboard/Dashboard.vue';
import InfoBeranda from './components/views/Backoffice/InfoBeranda/InfoBeranda.vue';
import ProsesInfoBeranda from './components/views/Backoffice/InfoBeranda/ProsesInfoBeranda.vue';
import Konten from './components/views/Backoffice/Konten/Konten.vue';
import ProsesKonten from './components/views/Backoffice/Konten/ProsesKonten.vue';
import Berita from './components/views/Backoffice/Berita/Berita.vue';
import ProsesBerita from './components/views/Backoffice/Berita/ProsesBerita.vue';
import DataDokumen from './components/views/Backoffice/NewDokumen/Dokumen.vue';
import Galeri from './components/views/Backoffice/Galeri/Galeri.vue';
import ProsesGaleri from './components/views/Backoffice/Galeri/ProsesGaleri.vue';
import DetailGaleri from './components/views/Backoffice/Galeri/DetailGaleri.vue';
import LayerPeta from './components/views/Backoffice/LayerPeta/LayerPeta.vue';
import User from './components/views/Backoffice/User/User.vue';
import ProsesUser from './components/views/Backoffice/User/ProsesUser.vue';
import Monev from './components/views/Backoffice/Monev/Monev.vue';
import ProsesMonev from './components/views/Backoffice/Monev/ProsesMonev.vue';
import ProsesPDOMonev from './components/views/Backoffice/Monev/ProsesPDOMonev.vue';
import AduanMasyarakat from './components/views/Backoffice/AduanMasyarakat/AduanMasyarakat.vue';
import ProsesAduanMasyarakat from './components/views/Backoffice/AduanMasyarakat/ProsesAduanMasyarakat.vue';
import TindaklanjutAduanMasyarakat from './components/views/Backoffice/AduanMasyarakat/TindaklanjutAduanMasyarakat.vue';
import PDOIOS from './components/views/Backoffice/PDOIOS/PDOIOS.vue';
import ProsesPDOIOS from './components/views/Backoffice/PDOIOS/ProsesPDOIOS.vue';
import Kegiatan from './components/views/Backoffice/Kegiatan/Kegiatan.vue';
import ProsesKegiatan from './components/views/Backoffice/Kegiatan/ProsesKegiatan.vue';
import Program from './components/views/Backoffice/Program/Program.vue';
import ProsesProgram from './components/views/Backoffice/Program/ProsesProgram.vue';
import Procurement from './components/views/Backoffice/Procurement/Procurement.vue';
import ProsesProcurement from './components/views/Backoffice/Procurement/ProsesProcurement.vue';
import Finance from './components/views/Backoffice/Finance/Finance.vue';
import ProsesFinance from './components/views/Backoffice/Finance/ProsesFinance.vue';
import Social from './components/views/Backoffice/Social/Social.vue';
import ProsesSocial from './components/views/Backoffice/Social/ProsesSocial.vue';
import Environment from './components/views/Backoffice/Environment/Environment.vue';
import ProsesEnvironment from './components/views/Backoffice/Environment/ProsesEnvironment.vue';
import Gesiap from './components/views/Backoffice/Gesiap/Gesiap.vue';
import ProsesGesiap from './components/views/Backoffice/Gesiap/ProsesGesiap.vue';
import Slider from './components/views/Backoffice/Slider/Slider.vue';
import ProsesSlider from './components/views/Backoffice/Slider/ProsesSlider.vue';
import SettingMenu from './components/views/Backoffice/SettingMenu/SettingMenu.vue';

import { useRoute } from 'vue-router';
import { watch } from 'vue';

export default {
  name: 'App',
  components: {
    Beranda,DaftarKonten,DaftarBerita,DaftarDokumen,DaftarDokumen,GIS,InputAduan,CariAduan
    ,MonitoringAduan,DaftarProgramBudgeting,DaftarFinance,DaftarGESIAP,Dashboard,InfoBeranda,ProsesInfoBeranda,Konten
    ,ProsesKonten,Berita,ProsesBerita,DaftarGaleri,LayerPeta
    ,DataDokumen,Galeri,ProsesGaleri,DetailGaleri,User,ProsesUser
    ,Monev,ProsesMonev,ProsesPDOMonev,AduanMasyarakat,ProsesAduanMasyarakat,TindaklanjutAduanMasyarakat
    ,PDOIOS,ProsesPDOIOS,Kegiatan,ProsesKegiatan,Program,ProsesProgram,Procurement,ProsesProcurement
    ,Finance,ProsesFinance,Social,ProsesSocial,Environment,ProsesEnvironment,Gesiap,ProsesGesiap,Slider,ProsesSlider
    ,SettingMenu
  },
  mounted() {
    document.title = "SIBERBI - SIMULASI BERUSAHA BANGUN INVESTASI";
  },
  setup() {
    const route = useRoute()
    watch(() => route.name, () => {
    });

    return { route };
  }
}
</script>

<style></style>
